import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { Section, Heading } from "../components/Bits";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const nextParam = searchParams.get("next");
  const redirect = nextParam || location.state?.from || "/";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Willkommen zurück!");
      navigate(redirect);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Section>
      <div className="max-w-md mx-auto plant-card p-8" data-testid="login-card">
        <img
          src="https://customer-assets.emergentagent.com/job_adventure-plants-lu/artifacts/iirha844_IMG_5450.png"
          alt="AdventureCouple.lu"
          className="h-20 w-auto mx-auto mb-4"
        />
        <Heading overline="Account" title="Anmelden" />
        <form onSubmit={submit} className="space-y-4">
          <input required type="email" placeholder="E-Mail" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-xl border" style={{ borderColor: "var(--wp-border)" }} data-testid="login-email" />
          <input required type="password" placeholder="Passwort" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-xl border" style={{ borderColor: "var(--wp-border)" }} data-testid="login-password" />
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit">{loading ? "Anmelden…" : "Anmelden"}</button>
        </form>
        <div className="text-sm text-center mt-6 opacity-70">
          Noch kein Account? <Link to="/register" className="text-[var(--wp-primary)] font-medium">Jetzt registrieren</Link>
        </div>
      </div>
    </Section>
  );
}
